module.exports = __webpack_public_path__ + "img/blog_menu_pic6.4b37b4c8.png";